
export default {
  name: 'ProductInfoGalleryImgInternalZoom',
  props: {
    image: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'large',
    },
    isCompare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEnabled: false,
    };
  },
  computed: {
    imgSrc() {
      if (this.isCompare) {
        return this.image.src;
      }

      return this.image.src.includes('/raw/')
        ? this.image.src
        : this.image.src.replace(/\/(pdpmain|catalog)\//g, '/raw/');
    },
  },
  methods: {
    zoomToggle() {
      this.isEnabled = !this.isEnabled;
    },
    zoomTurnOff() {
      this.isEnabled = false;
    },
  },
};
